import PropTypes from 'prop-types';

const PrepareAISummaryView = ({ localisedValues }) => {
  return (
    <div className="no-session-data custom-scroll-div">
      <div className="no-session-data-in">
        <div className="no-session-data-box">
          <div className="loader-icon">
            <span className="for-icon icon-loader spin"></span>
          </div>
          <h4>{localisedValues?.analyzing_your_call}</h4>
          <p>
            {localisedValues?.every_great_summary_takes_a_moment} {localisedValues?.we_are_turning_your_call_into_something_neat_and_readable}
          </p>
        </div>
      </div>
    </div>
  );
};

PrepareAISummaryView.propTypes = {
    localisedValues: PropTypes.object,
};

export default PrepareAISummaryView;
